<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
import PageAlerts from "@/components/page-alerts";
import moment from "moment";

export default {
  page: {
    title: "Record Fees Payments",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    PageAlerts,
  },
  data() {
    return {
      title: "Record Fees Payments",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Pay Fees",
          active: true,
        },
      ],
      pay: {
        id: "",
        amount: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
        paidby: "",
        slip: "",
        feesItem: "",
      },
      warningData: {
        name: "",
        amount: "",
        mode: "",
        paidby: "",
        slip: "",
        feesItem: "",
      },
      max: 0,
      amountError: "",
      studentError: "",
      modeError: "",
      feesItemError: "",
    };
  },
  computed: {
    ...mapGetters("modes", ["Modes"]),
    ...mapGetters("students", ["AllStudents1"]),
    ...mapGetters("fees", ["getPayFeesItems", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("settings", ["getSystemSettings"]),
  },
  watch: {
    getPayFeesItems(newValue) {
      if (newValue) {
        this.assignAmount();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStudents: "students/fetchStudents1",
      FetchModes: "modes/fetchModes",
      Pay: "fees/pay",
      PayFeesItems: "fees/payFeesItems",
      FetchItems: "fees/fetchItems",
      FetchSystemSettings: "settings/fetchSystemSettings",
    }),
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
      this.studentError = "";
    },
    addCommas() {
      this.pay.amount = this.thousandSeperater(this.pay.amount);
    },
    redirect(value) {
      this.$router.push(`/fees/receipt/${btoa(value)}`);
    },
    payFees(modal) {
      if (this.pay.amount == "") {
        this.amountError = "Amount Paid field can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      if (this.pay.id == "") {
        this.studentError = "Please select a student you are paying for";
        return;
      } else {
        this.studentError = "";
      }
      if (this.pay.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }

      //check for selected fees item
      if (
        this.getSystemSettings.find(
          (setting) =>
            setting.setting_key == "AUTO_FEES_BREAKDOWN" && setting.value == 0
        )
      ) {
        if (this.pay.feesItem == "") {
          this.feesItemError = "Fees Item is required";
          return;
        } else {
          this.feesItemError = "";
        }
      }

      //setting up confirmation modal
      const student = this.AllStudents1.find((item) => item.id == this.pay.id);
      const mode = this.Modes.find((item) => item.id == this.pay.mode);
      let newFeesItem = "Overall Payment";
      if (this.pay.feesItem != "") {
        const selectedItem = this.getPayFeesItems.find(
          (item) => item.item_id == this.pay.feesItem
        );
        newFeesItem = selectedItem.name;
      }
      this.warningData = [
        { name: "Name", value: student.name },
        { name: "Amount", value: this.pay.amount + " UGX" },
        { name: "Pyment", value: mode.name1 },
        { name: "Paid by", value: this.pay.paidby },
        { name: "Slip/Ref", value: this.pay.slip },
        { name: "Item", value: newFeesItem },
      ];
      this.showModal(modal);
    },
    confirmedPayment(modal) {
      this.Pay(this.pay);
      this.resetError();
      this.reset();
      this.closeModal(modal);
    },
    fetchFeesItems() {
      this.pay.amount = 0;
      this.max = 0;
      this.PayFeesItems({ id: this.pay.id });
    },
    assignAmount() {
      if (
        this.getSystemSettings.find(
          (setting) =>
            setting.setting_key == "AUTO_FEES_BREAKDOWN" && setting.value == 0
        )
      ) {
        const selectedItem = this.getPayFeesItems.find(
          (item) => item.item_id == this.pay.feesItem
        );
        const selectedAmount = selectedItem ? parseInt(selectedItem.amount) : 0;
        this.pay.amount = this.thousandSeperater(selectedAmount);
        this.max = selectedAmount;
      } else {
        const amount = this.getPayFeesItems.reduce(
          (sum, item) => parseInt(sum) + parseInt(item.amount),
          0
        );
        this.pay.amount = this.thousandSeperater(amount);
        this.max = parseInt(amount);
      }
    },
    reset() {
      this.pay.amount = "";
      this.pay.id = "";
      this.pay.mode = "";
      this.pay.slip = "";
      this.pay.paidby = "";
      this.pay.date = moment(new Date()).format("YYYY-MM-DD");
    },
    restrictAmount() {
      const amount = parseInt(this.pay.amount.replace(/,/g, ""));
      if (amount > this.max) {
        this.pay.amount = this.thousandSeperater(this.max);
      } else {
        this.pay.amount = this.thousandSeperater(this.pay.amount);
      }
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    showModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.show(modalId);
      });
    },
  },
  created() {
    this.FetchItems();
    this.FetchStudents();
    this.FetchModes();
    this.FetchSystemSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('make_fees_payments')
        )
      "
    >
      <div class="col-md-10 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title text-primary">
              Select the the details of the Student you are Paying
            </h3>
            <form @submit.prevent="payFees('check-payment-modal')">
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Student</label>
                  <div class="input-group">
                    <model-list-select
                      required
                      :list="AllStudents1 ? AllStudents1 : []"
                      v-model="pay.id"
                      option-value="id"
                      option-text="names"
                      class="mb-2"
                      @input="resetError(), fetchFeesItems()"
                      placeholder="Select Student"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="studentError">
                    <em>{{ studentError }}</em>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>Paid By</label>
                  <div class="input-group">
                    <input
                      type="text"
                      placeholder="Person who paid fees"
                      class="form-control"
                      v-model="pay.paidby"
                    />
                  </div>
                </div>
                <div
                  class="form-group col-md-6"
                  v-if="
                    getSystemSettings &&
                      getSystemSettings.find(
                        (setting) =>
                          setting.setting_key == 'AUTO_FEES_BREAKDOWN' &&
                          setting.value == 0
                      )
                  "
                >
                  <label>Payments For </label>
                  <div class="input-group">
                    <model-list-select
                      required
                      :list="getPayFeesItems ? getPayFeesItems : []"
                      v-model="pay.feesItem"
                      option-value="item_id"
                      option-text="name_amount"
                      class="mb-2"
                      @input="resetError(), assignAmount()"
                      placeholder="Select Fees Item"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="feesItemError">
                    <em>{{ feesItemError }}</em>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label
                    >Amount
                    <small class="">
                      Balance: <b>{{ max }}</b>
                      <br />
                      <b>Unpaid: </b>
                      <span v-for="(fee, index) in getPayFeesItems" :key="index"
                        >{{ fee.item_name }}({{
                          thousandSeperater(fee.amount)
                        }}),</span
                      >
                    </small>
                  </label>
                  <div class="input-group">
                    <input
                      type="text"
                      placeholder="Enter Amount"
                      class="form-control"
                      @input="resetError(), restrictAmount()"
                      v-model="pay.amount"
                    />
                  </div>
                  <div class="text-danger" v-if="amountError">
                    <em>{{ amountError }}</em>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>Payment Date</label>
                  <div class="input-group">
                    <input
                      type="date"
                      class="form-control"
                      v-model="pay.date"
                    />
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="col-form-label">Payment Method</label>
                  <div class="input-group">
                    <model-list-select
                      :list="Modes ? Modes : []"
                      v-model="pay.mode"
                      option-value="id"
                      option-text="name1"
                      class="mb-3"
                      placeholder="Select Payment Method"
                      @input="resetError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="modeError">
                    <em>{{ modeError }}</em>
                  </div>
                </div>
                <div class="form-group mb-2 col-md-6">
                  <label>Slip Number</label>
                  <div class="input-group">
                    <input
                      type="number"
                      placeholder="Enter Slip Number"
                      class="form-control"
                      v-model="pay.slip"
                    />
                  </div>
                  <small class="text-primary"
                    >Bank Slip Number Or Reference Number</small
                  >
                </div>
              </div>
              <hr />
              <div class="form-group mb-1 float-end">
                <button
                  disabled
                  class="btn btn-outline-primary"
                  v-if="SaveStatus"
                >
                  <b-spinner
                    variant="primary"
                    small
                    label="Submitting..."
                  ></b-spinner>
                  Paying Fees...
                </button>
                <button class="btn btn-outline-primary" type="submit" v-else>
                  <i class="fa fa-check" aria-hidden="true"></i> Save Payment
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- modal starts -->
      <b-modal id="check-payment-modal" size="lg" hide-footer>
        <template #modal-title>
          <b>Review and Confirm Payment.</b>
        </template>
        <div class="row d-flex">
          <div class="col-md-10 mx-auto">
            <table class="borderless">
              <tbody>
                <tr v-for="(item, index) in warningData" :key="index">
                  <td>
                    <h5>{{ item.name }}:</h5>
                  </td>
                  <td class="ml-3">&ensp; &emsp;{{ item.value }}</td>
                </tr>
              </tbody>
            </table>
            <div class="mt-3">
              <PageAlerts
                title="PLEASE NOTE !!!"
                primaryMsg="Please carefully review the payment details. This action is permanent and cannot be undone."
                alertType="warning"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              data-dismiss="modal"
              @click="closeModal('check-payment-modal')"
            >
              <i class="fa fa-times"></i> Check Again
            </button>
            <button
              type="submit"
              size="sm"
              disabled
              class="btn btn-primary btn-sm"
              v-if="SaveStatus"
            >
              <b-spinner variant="primary" small label="Paying..."></b-spinner>
              Paying...
            </button>
            <button
              v-else
              @click="confirmedPayment('check-payment-modal')"
              size="sm"
              class="btn btn-primary btn-sm"
            >
              <i class="fa fa-check"></i>
              Confirm Payment
            </button>
          </div>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
